import * as React from 'react';
import {Route, HashRouter} from 'react-router-dom';

import {ScheduledEmailEditModal} from './scheduled-email-edit-modal';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function ScheduledEmailEditModalRoot(props: Props) {
    if (props.isOpen) {
        return (
            <HashRouter>
                <Route
                    path='/edit-scheduled-email/:scheduledEmailId'
                    render={({match}) => {
                        const emailId = match.params.scheduledEmailId;

                        if (emailId) {
                            return (
                                <ScheduledEmailEditModal
                                    isOpen={props.isOpen}
                                    onClose={props.onClose}
                                    scheduledEmailId={emailId}
                                />
                            );
                        }

                        return null;
                    }}
                />
            </HashRouter>
        );
    }

    return null;
}
